import Vue from 'vue';

import './axios';
import './dayjs';
import './echo';
import './route';
import './events';
import './vue-bootstrap';
import './components';
import './vue-echarts';
import './toaster';

Vue.config.devtools = window.appConfig.env !== 'production';
